import { Button } from './Button';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
	// React.ComponentType<Record<string, unknown>> is compatible with phosphor-icons
	// whose weight prop is a strict union type — looser than ComponentType<{size?;weight?}>
	icon: React.ComponentType<Record<string, unknown>>;
	title: string;
	description: string;
	action?: { label: string; onClick: () => void };
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
	return (
		<div className={styles.emptyState}>
			<div className={styles.icon}>
				<Icon size={48} weight="duotone" />
			</div>
			<p className={styles.title}>{title}</p>
			<p className={styles.description}>{description}</p>
			{action && (
				<div className={styles.action}>
					<Button variant="primary" onClick={action.onClick}>
						{action.label}
					</Button>
				</div>
			)}
		</div>
	);
}
